/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Link } from '@mui/material';

// Converts markdown-style links [text](url) to JSX Link elements
// @param {string} text - Text containing markdown links
// @returns {Array|string} - Array of JSX elements and strings, or original string if no links
export const parseMarkdownLinks = (text) => {
    if (!text || typeof text !== 'string') {
        return text;
    }

    // Regex to match markdown links: [text](url)
    const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const matches = [...text.matchAll(markdownLinkRegex)];

    if (matches.length === 0) {
        return text;
    }

    const elements = [];
    let lastIndex = 0;

    matches.forEach((match, i) => {
        const [fullMatch, linkText, url] = match;
        const { index } = match;

        // Add text before the link
        if (index > lastIndex) {
            elements.push(text.substring(lastIndex, index));
        }

        // Add the link element
        elements.push(
            <Link
                key={`markdown-link-${i}`}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main', textDecoration: 'underline' }}
            >
                {linkText}
            </Link>
        );

        lastIndex = index + fullMatch.length;
    });

    // Add remaining text after the last link
    if (lastIndex < text.length) {
        elements.push(text.substring(lastIndex));
    }

    return elements;
};

export const MarkdownText = ({ children, ...props }) => {
    const parsed = parseMarkdownLinks(children);

    return <span {...props}>{parsed}</span>;
};
